module.exports = __webpack_public_path__ + "img/8.7254dd3e.png";